export function containsNonIdentChars(str) {
  // Remove array access patterns
  const cleanedStr = str.replace(/\[(\d+|\*)\]/g, '');
  return /[^a-zA-Z_.]/.test(cleanedStr);
}

export function duplicate(object) {
  return JSON.parse(JSON.stringify(object));
}
